import { formatDistanceToNow } from "date-fns"
import { ru } from "date-fns/locale"

export const formatTimeAgo = (date: Date | string): string => {
  if (!date) return ''

  try {
    return formatDistanceToNow(new Date(date), {
      addSuffix: true,
      locale: ru,
    })
  } catch {
    return ''
  }
}
